import {Component, OnInit} from '@angular/core';
import {CallsApiService} from '../../services/api/calls/calls-api.service';
import {ConfigurationService} from '../../services/common/configuration/configuration.service';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {DateTimePipe} from '../../pipes/date-time/date-time.pipe';
import {PageEventCursorInf} from '../../classes/common/table/page-event-cursor';
import _ from 'lodash';
import {CallsDialogComponent} from './calls-dialog/calls-dialog.component';
import {AcDialogService} from 'ac-infra';
import {TestRouteService} from '../../network/services/map/test-route/test-route.service';
import {
  TableColumnsConfigurationDialogComponent
} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute} from '@angular/router';
import dayjs from 'dayjs';

@Component({
  selector: 'calls',
  templateUrl: './calls.component.html',
  styleUrls: ['./calls.component.scss']
})
export class CallsComponent implements OnInit {

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'srcUriBeforeManipulation', display: 'Source', selected: true, width: 230},
    {name: 'dstUriBeforeManipulation', display: 'Destination', selected: true, width: 230},
    {name: 'armSetupTime', display: 'Date And Time', selected: true, transformer: DateTimePipe, width: 150},
    {name: 'incomingNodeName', display: 'Incoming node', selected: true, width: 150},
    {name: 'incomingPconName', display: 'Incoming peer connection', selected: true, width: 120},
    {name: 'incomingCustomerName', display: 'Incoming customer', selected: true, width: 110},
    {name: 'outgoingNodeName', display: 'Outgoing node', selected: true, width: 150},
    {name: 'outgoingPconName', display: 'Outgoing peer connection', selected: true, width: 120},
    {name: 'outgoingCustomerName', display: 'Outgoing customer', selected: true, width: 110},
    {name: 'routingRuleName', display: 'Routing rule', selected: true, width: 200},
    {name: 'policyNames', display: 'Policy studios rules', selected: true, width: 200},
    {name: 'sipTerminationReason', display: 'SIP reason', selected: true, width: 70},
    {name: 'sessionId', display: 'Session Id', selected: true, width: 150},
  ];

  data: any;
  pageEventCursor: any;

  datePickerOptions;
  defaultStartDate;
  defaultEndDate;

  externalData: any;
  policyStudios: any;

  incomingPconOptions;
  outgoingPconOptions;
  customerOptions;
  search: any;
  waitingForResponse: boolean;
  abort: boolean;
  callsSummary: any;

  constructor(private callsApiService: CallsApiService,
              private configurationService: ConfigurationService,
              private testRoute: TestRouteService,
              private dialog: AcDialogService,
              private route: ActivatedRoute,
              private matDialog: MatDialog) {

  }

  ngOnInit(): void {
    let filter: any;
    this.datePickerOptions = this.configurationService.getDatePickerOptions();
    if (this.route.snapshot.params){
      filter =  this.route.snapshot.params;
    }
    this.search = this.generateDefaultSearch(filter);
    this.init();
  }

  pageChanged(event: PageEventCursorInf): void {
    this.pageEventCursor = event;
    this.refresh();
  }

  onSelection(call: any): void {
    this.callsApiService.getCallDetails(call.sessionKey).subscribe(details => {

      this.addMoreInfoForCallDetails(details, this.externalData);
      this.dialog.open(CallsDialogComponent, {
        height: 1100,
        width: 1600,
        title: 'Call details',
        cancelButtonText: 'Close',
        noSubmitButton: true,
        dialogData: {
          details
        }
      });
    });
  }

  addMoreInfoForCallDetails(call, externalData): void {
    call.status = this.setCallStatus(call, null, call.cdrSessionPathList.length - 1);
    call.cdrSessionPathList.forEach((path, $index) => {
      path.id = ($index + 1);
      path.displayName = 'Path ' + path.id;
      path.status = this.setCallStatus(call, path, $index);
      path.icon = this.setLastPathIcon(call, path, $index);
      path.srcNode = call.incomingNodeId;
      path.srcPeerConnection = call.incommingPconId;
      path.srcPeerConnectionName = this.generatePConName(call.incommingPconId, call.incomingNodeId);
      path.destPeerConnectionName = this.generatePConName(path.destPeerConnection, path.destNode);
      path.destNodeName = this.addElementName(call.outgoingNodeId, this.externalData.nodes);
      path.incomingCustomerName = this.addElementName(call.incomingCustomerId, this.externalData.customers);
      path.outgoingCustomerName = this.addElementName(call.outgoingCustomerId, this.externalData.customers);
      path.srcConnection = call.incommingConnectionId;
      path.routerName = this.findRouterName(path.routerIp, path.routerId, externalData.routers);
      path.routingRuleName = this.findRoutingRuleName(path.routingRuleId, externalData.routingRules);
      path.manipulations = this.testRoute.constructDataForTestRouteDetailsGrid(call, [path]);
    });
  }

  setCallStatus(call, path, index): string {
    if (path && path.unselectedRule) {
      return 'Unselected Rule';
    }

    if (path == null) {
      if (call.success) {
        return 'Success';
      }

      if (call.voiceDuration > 0) {
        return 'Success';
      }

      return 'Failure';
    }

    if (!path.success && !(path.voiceDuration > 0)){
      return 'Failure';
    }

    if (call.discardingByRoutingRule && call.discardingByRoutingRule > 0 && index === call.cdrSessionPathList.length - 1) {
      return 'Success';
    }

    if (call.continueWithNodeInternalTablesByRoutingRule &&
      call.continueWithNodeInternalTablesByRoutingRule > 0
      && index === call.cdrSessionPathList.length - 1) {
      return 'Success';
    }

    if (path.voiceDuration > 0) {
      return 'Success';
    }

    return 'Failure';
  }

  setLastPathIcon(call, path, index): string {
    if (path && path.unselectedRule) {
      return 'fa-ban';
    }
    if (call.discardingByRoutingRule && call.discardingByRoutingRule > 0 && index === call.cdrSessionPathList.length - 1) {
      return 'fa-ban success';
    }
    if (call.continueWithNodeInternalTablesByRoutingRule &&
      call.continueWithNodeInternalTablesByRoutingRule > 0 &&
      index === call.cdrSessionPathList.length - 1) {
      return 'fa-sign-out success';
    }
    if (path.voiceDuration > 0) {
      return 'fa-check-circle success';
    }

    return 'fa-times-circle failure';
  }

  private generatePConName(pConId, nodeId): string {
    if (_.isNil(pConId)) {
      return null;
    }

    return `${this.addElementName(pConId, this.externalData.pcons)}
            (${this.addElementName(nodeId, this.externalData.nodes)})`;
  }

  findRouterName(ip, routerId, routers): string {
    let router;

    if (routerId && routerId !== -1) {
      router = routers.find(routerItem => routerItem.id === routerId);
    }
    if (!router) {
      router = routers.find(routerItem => routerItem.address === ip);
    }
    if (router) {
      return router.name + ' (' + ip + ')';
    } else {
      return ip + ' (Deleted)';
    }
  }

  findRoutingRuleName(id, rules): string {
    if (id <= 0) {
      return 'No match';
    }

    const rr = rules.find(rule => rule.id === id);
    if (rr) {
      return rr.name;
    } else {
      return id + ' (Deleted)';
    }
  }


  private init(): void {
    this.pageEventCursor = {
      before: null,
      after: null,
      pageSize: 25
    };

    this.callsApiService.getCallFilterExternalData().then(data => {
      this.externalData = data;
      this.incomingPconOptions = data.pcons;
      this.outgoingPconOptions = data.pcons;
      this.customerOptions = data.customers;
      this.policyStudios = data.policyStudios;

      this.refresh();
    }, err => {
      console.log(`Exception was thrown in init calls ${err}`);
    });
  }

  addElementsNames(calls): void {
    calls.forEach(call => {
      call.incomingNodeName = this.addElementName(call.incomingNodeId, this.externalData.nodes);
      call.outgoingNodeName = this.addElementName(call.outgoingNodeId, this.externalData.nodes);
      call.incomingPconName = this.addElementName(call.incommingPconId, this.externalData.pcons);
      call.outgoingPconName = this.addElementName(call.outgoingPconId, this.externalData.pcons);
      call.routingRuleName = this.addElementName(call.routingRuleId, this.externalData.routingRules);
      call.incomingCustomerName = this.addElementName(call.incomingCustomerId, this.externalData.customers);
      call.outgoingCustomerName = this.addElementName(call.outgoingCustomerId, this.externalData.customers);
      call.policyNames = this.addPolicyStudioNames(call.policyStudioList);
    });
  }

  addElementName(id, elements): string {
    if (id === null) {
      return '';
    } else if (id === -1) {
      return 'No match';
    }

    const element = elements.find(e => e.id === id);
    if (element) {
      return element.name;
    } else {
      return id + ' (Deleted)';
    }
  }

  refresh(): void {
    this.waitingForResponse = true;

    const params = {
      limit: this.pageEventCursor.pageSize,
      cursor: _.isNil(this.pageEventCursor.after) ? null : this.pageEventCursor,
      search: this.search
    };

    this.callsSummary = this.callsApiService.getCallsSummary(params).subscribe(
      data => {
        if (this.externalData) {
          this.setData(data);
          this.waitingForResponse = false;
        }
      });
  }

  setData(data: any): void {
    this.addElementsNames(data.calls);
    this.data = data.calls;
    this.pageEventCursor.before = data.cursor.before;
    this.pageEventCursor.after = data.cursor.after;
  }

  private generateDefaultSearch(filter: any  = {}): any {
    this.defaultStartDate = dayjs().startOf('day');

    this.defaultEndDate = dayjs().endOf('day');

    const filterStartDate = filter.startDate ? dayjs(filter.startDate * 1000) : null;
    const filterEndDate = filter.endDate ? dayjs(filter.endDate * 1000) : null;



    return {
      incomingNodeId: null,
      incommingPconId: null,
      incomingCustomerId: null,
      outgoingNodeId: null,
      outgoingPconId: null,
      outgoingCustomerId: null,
      routingRuleId: null,
      srcUriBeforeManipulation: filter.source ? filter.source : null,
      dstUriBeforeManipulation: filter.destination ? filter.destination : null,
      policyStudioId: filter.policyStudioId ? parseInt(filter.policyStudioId, 10) : null,

      date: {
        startDate: filterStartDate ? filterStartDate : this.defaultStartDate,
        endDate: filterEndDate ? filterEndDate : this.defaultEndDate
      },
      enableDate: true,
      regExpSearch: false
    };
  }

  clear(): void {
    this.search = this.generateDefaultSearch();
    this.refresh();
  }

  abortRequest(): void {
    this.abort = true;
    this.callsSummary.unsubscribe();
    this.refresh();
  }

  isEmptySearchParameters(): boolean {
    return this.isEmptySearchItem(this.search.incomingNodeId) && this.isEmptySearchItem(this.search.incommingPconId) &&
      this.isEmptySearchItem(this.search.sessionId) && this.isEmptySearchItem(this.search.incomingCustomerId) &&
      this.isEmptySearchItem(this.search.outgoingNodeId) && this.isEmptySearchItem(this.search.outgoingPconId) &&
      this.isEmptySearchItem(this.search.outgoingCustomerId) && this.isEmptySearchItem(this.search.routingRuleId) &&
      this.isEmptySearchItem(this.search.srcUriBeforeManipulation) && this.isEmptySearchItem(this.search.dstUriBeforeManipulation) &&
      this.isEmptySearchItem(this.search.policyStudioId) && this.isEmptySearchItem(this.search.sipTerminationReason);
  }

  onIncomingNodeChange(nodeId: any): void {
    if (nodeId) {
      this.incomingPconOptions = this.incomingPconOptions.filter(pcon => pcon.nodeId === nodeId);
    } else {
      this.incomingPconOptions = this.externalData.pcons;
    }
  }

  onOutgoingNodeChange(nodeId): void {
    if (nodeId) {
      this.outgoingPconOptions = this.outgoingPconOptions.filter(pcon => pcon.nodeId === nodeId);
    } else {
      this.outgoingPconOptions = this.externalData.pcons;
    }
  }

  export(): any {
    this.callsApiService.exportCalls({search: this.search});
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.matDialog.open(TableColumnsConfigurationDialogComponent, {
      width: '450px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  private isEmptySearchItem(item): boolean {
    return _.isNil(item) || item === '';
  }

  private addPolicyStudioNames(policyStudioList: any): any {
    if (!policyStudioList){
      return [];
    }

    return policyStudioList.map(poly => {
      const value = _.find(this.policyStudios, {id: poly});
      return (value ? value.name : poly + ' (Deleted)');
    });
  }
}
